(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lubab-home-final"]) return;
  try {
    
(() => { const root=document.currentScript.closest('.lhf'); if(!root) return; const slides=[...root.querySelectorAll('.lhf-slide')], dots=[...root.querySelectorAll('[data-lhf-dot]')]; let index=0,timer; const show=(n)=>{index=(n+slides.length)%slides.length;slides.forEach((s,i)=>s.classList.toggle('is-active',i===index));dots.forEach((d,i)=>d.classList.toggle('active',i===index));}; const next=()=>show(index+1); const start=()=>{clearInterval(timer);timer=setInterval(next,5500)}; root.querySelector('[data-lhf-next]').addEventListener('click',()=>{next();start()});root.querySelector('[data-lhf-prev]').addEventListener('click',()=>{show(index-1);start()});dots.forEach(d=>d.addEventListener('click',()=>{show(Number(d.dataset.lhfDot));start()}));start(); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
